import React from 'react';
import dayjs from 'dayjs';
import { Box, Group, Progress, Text } from '@mantine/core';

import { HistoricalItem } from '../types';

type MealHistoricalItemProps = {
  historical: HistoricalItem;
  maxSold: number;
};

const MealHistoricalItem: React.FC<MealHistoricalItemProps> = ({
  historical: {
    popupEvent: { eventStartTime: start },
    sales,
  },
  maxSold,
}) => {
  return (
    <>
      <Text fz="sm">
        {dayjs(start).format('MM/DD')}
        <Text fz="sm" span c="dimmed" ml="4">
          {dayjs(start).format('ddd')}
        </Text>
      </Text>
      <Group gap="sm" wrap="nowrap" align="center">
        <Box w="100%">
          <Progress
            size="lg"
            radius="xs"
            value={Math.round(((sales?.mealsSold ?? 0) / maxSold) * 100)}
          />
        </Box>
        <Box miw="2rem">
          <Text fw="bold">{sales?.mealsSold}</Text>
        </Box>
      </Group>
    </>
  );
};

export default MealHistoricalItem;
